import { gql } from "@apollo/client";

export const createOnsiteEmployeeDetails = gql`
  mutation createonsitedetails($input: CreateOnsiteEmployeedetailsInput!) {
    createOnsiteEmployeeDetails(input: $input) {
      success

      message
    }
  }
`;

export const updateOnsiteEmployeeDetails = gql`
  mutation updateonsitedetails($input: UpdateOnsiteEmployeeDetailsInput!) {
    updateOnsiteEmployeeDetails(input: $input) {
      success
      message
    }
  }
`;

export const deleteOnsiteEmployeeDetails = gql`
  mutation deleteemployeedetails($id: ID!) {
    deleteOnsiteEmployeeDetails(id: $id) {
      success

      message
    }
  }
`;

export const onsitechangeStatus = gql`
  mutation updateonsitedetails($input: UpdateOnsiteEmployeeDetailsInput!) {
    updateOnsiteEmployeeDetails(input: $input) {
      success

      message
    }
  }
`;
export const allOnsiteActiveScreen = gql`
  query {
    allOnsiteActiveScreen {
      id
      type
      employeeId
      employeeName
      lastUpdate
      lastVisaExpiryDate
      visaDaysRemaining
    }
  }
`;
export const allOnsiteInactiveScreen = gql`
  query {
    allOnsiteInactiveScreen {
      id

      employeeId
      type
      employeeName

      statusChangeDate
    }
  }
`;

export const getOnsiteEmployeeDetails = gql`
  query getOnsiteEmployeeDetails($id: ID!) {
    getOnsiteEmployeeDetails(id: $id) {
      id

      type

      employeeName

      employeeId

      email

      phoneNo

      passportNo

      experience

      joiningDate

      projectName

      onsitedoumentationsSet {
        id

        documentSubmissionMail

        documentComments

        medicalTestApplied

        medicalTestAppliedComments

        medicalTestReport

        medicalTestReportComments

        biometric

        biometricComments

        documentSubmission

        documentSubmissionComments

        documentReturned

        documentReturnedComments

        visaStamped

        visaStampedComments
        startFromIndia
        startFromIndiaComments

        reachedOnSite

        reachedOnSiteComments

        visaExpiryDays

        visaExpiryDate

        visaExpiryComments

        startFromOnsite

        startFromOnsiteComments

        returnedToCountry

        returnedToCountryComments
      }
    }
  }
`;

export const generateOnsitePdf = gql`
  mutation GeneratePdf($id: Int!, $documentIds: [Int!]!) {
    generateOnsitePdf(id: $id, documentIds: $documentIds) {
      success
      message
      pdfUrl
    }
  }
`;
